import React from 'react';
import clsx from 'clsx';
import { useStyles } from './styles';
const BaseDivider = ({ className }) => {
    const ownClasses = useStyles();
    return React.createElement("hr", { className: clsx(ownClasses.root, className) });
};
export default BaseDivider;
